import { Toaster } from 'react-hot-toast'
import Header from './components/Header'
import Footer from './components/Footer'
import ThemeProvider from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import HomePage from './pages/HomePage'
import AccountPage from './pages/AccountPage'
import UpdateCardPage from './pages/UpdateCardPage'
import CheckoutPage from './pages/CheckoutPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import TermsOfUsePage from './pages/TermsOfUsePage'
import ScrollToTop from './components/ScrollToTop'

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen w-full max-w-[100vw] overflow-x-hidden bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
            {/* Skip link – acessibilidade (teclado) */}
            <a
              href="#main-content"
              className="fixed left-4 top-4 z-[100] -translate-y-20 focus:translate-y-0 focus:outline-none rounded-xl bg-accent text-white px-5 py-3 font-bold text-sm shadow-lg transition-transform duration-200"
            >
              Pular para o conteúdo
            </a>
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/checkout/:planId" element={<CheckoutPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/account/update-card" element={<UpdateCardPage />} />
              <Route path="/privacidade" element={<PrivacyPolicyPage />} />
              <Route path="/termos" element={<TermsOfUsePage />} />
            </Routes>
            <Footer />
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 3000,
                className: 'toast-container',
                style: {
                  background: 'var(--toast-bg, #ffffff)',
                  color: 'var(--toast-color, #1a1a1a)',
                  border: '2px solid #22C65E',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '600',
                  padding: '16px',
                  boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
                },
                success: {
                  iconTheme: {
                    primary: '#22C65E',
                    secondary: '#ffffff',
                  },
                  style: {
                    background: '#ffffff',
                    color: '#1a1a1a',
                    border: '2px solid #22C65E',
                  },
                },
                error: {
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#ffffff',
                  },
                  style: {
                    background: '#ffffff',
                    color: '#1a1a1a',
                    border: '2px solid #ef4444',
                  },
                },
              }}
            />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App

